/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IdentificationStatusNR = {
    NeverIdentified: 'NeverIdentified',
    InProgress: 'InProgress',
    Identified: 'Identified',
    OutdatedDueToError: 'OutdatedDueToError',
    Failed: 'Failed',
    Blocked: 'Blocked'
} as const;
export type IdentificationStatusNR = typeof IdentificationStatusNR[keyof typeof IdentificationStatusNR];


export function instanceOfIdentificationStatusNR(value: any): boolean {
    for (const key in IdentificationStatusNR) {
        if (Object.prototype.hasOwnProperty.call(IdentificationStatusNR, key)) {
            if (IdentificationStatusNR[key as keyof typeof IdentificationStatusNR] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IdentificationStatusNRFromJSON(json: any): IdentificationStatusNR {
    return IdentificationStatusNRFromJSONTyped(json, false);
}

export function IdentificationStatusNRFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentificationStatusNR {
    return json as IdentificationStatusNR;
}

export function IdentificationStatusNRToJSON(value?: IdentificationStatusNR | null): any {
    return value as any;
}

export function IdentificationStatusNRToJSONTyped(value: any, ignoreDiscriminator: boolean): IdentificationStatusNR {
    return value as IdentificationStatusNR;
}

